import React from 'react';
import { Button, Modal, Spinner, Table } from 'flowbite-react';
type Props = {
    isOpen: boolean;
    onClose: () => void;
    data: Record<string, string>[];
    header?: string;
    isLoading?: boolean;
};
const UpdatedUserModal: React.FC<Props> = ({ isOpen, onClose, data, header, isLoading }) => {
    if (!isOpen) return <div />;
    const keyMap = {
        'Name': 'name',
        'Email': 'email',
        'Phone': 'phone',
        'Alternative Name 1': 'alternativeName1',
        'Alternative Email 1': 'alternativeEmail1',
        'Alternative Phone 1': 'alternativePhone1',
        'Alternative Name 2': 'alternativeName2',
        'Alternative Email 2': 'alternativeEmail2',
        'Alternative Phone 2': 'alternativePhone2',
        'Result': 'result',
    };

    // const keys = ['Sr. No', 'Name', 'Email', 'Phone', 'Result'];
    const keys = ['Sr. No', 'Name', 'Email', 'Phone', 'Alternative Name 1', 'Alternative Email 1', 'Alternative Phone 1', 'Alternative Name 2', 'Alternative Email 2', 'Alternative Phone 2', 'Result'];
    return (
        <Modal dismissible={true} show={isOpen} onClose={onClose} size="6xl">
            <Modal.Header className="bg-blue-50">{header || 'NEW USERS'}</Modal.Header>
            <Modal.Body>
                <div className="max-w-full whitespace-pre grid grid-cols-1 overflow-auto">
                    <Table striped={true}>
                        <Table.Head>
                            {keys.map((keyName, index) => (
                                <Table.HeadCell key={index} className="uppercase">
                                    {keyName}
                                </Table.HeadCell>
                            ))}
                        </Table.Head>
                        <Table.Body>
                            {data.map((user, index) => (
                                <Table.Row key={index}>
                                    <Table.Cell>{index + 1}</Table.Cell>
                                    {/* {keys.slice(1).map((keyName, i) => (
                                        <Table.Cell key={i}>{user[keyName.toLowerCase()]}</Table.Cell>
                                    ))} */}
                                    {Object.keys(keyMap).map((display, i) => (
                                        <Table.Cell key={i}>{user[keyMap[display as keyof typeof keyMap]]}</Table.Cell>
                                    ))}
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    );
};

export default UpdatedUserModal;
